
import I18n_fr from "./I18n_fr";
import I18n_en from "./I18n_en";
import I18n_es from "./I18n_es";
import I18n_eu from "./I18n_eu";

var I18n = require("i18n-js");

I18n.fallbacks = true;

I18n.translations = {
  fr: I18n_fr,
  en: I18n_en,
  es: I18n_es,
  eu: I18n_eu
};

export default I18n;
